import kinto from './kinto';
import cs4rs from './kinto';
import inroads from './inroads';
import stratos from './stratos';
import prevost from './prevost';
import buscity from './prevost';
import riderclub from './riderclub';
import motocity from './riderclub';
import launchmobility from './launchmobility';

export default {
  cs4rs,
  kinto,
  buscity,
  inroads,
  stratos,
  motocity,
  prevost,
  riderclub,
  default: launchmobility,
};
